const parseUtm = (url, utmFlags, override = true) => {
	const urlObj = new URL(url);

	Object.entries(utmFlags).forEach(([key, val]) => {
		if (override || !urlObj.searchParams.has(key)) {
			urlObj.searchParams.set(key, val);
		}
	});

	return urlObj.href;
};

export default parseUtm;
